import { request } from '@langlois/request';

export async function getActiveInvitations ({ commit }, clubId) {
	const url = new URL(`${process.env.VUE_APP_API_URI}/club/member/invitation?clubId=${clubId}`);

	try {
		const response = await request.get(url);

		const { ok, status } = response;

		if (!ok) return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the invitations.`,
			type: `warning`
		}, { root: true });

		if (status === 204) return;

		const invitations = await response.json();

		commit(`setInvitations`, invitations);
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the invitations.`,
			type: `warning`
		}, { root: true });
	}
}
